import { isMobileOnly } from "react-device-detect";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import Cell from "../Cell";
import ModulePriceDialog from "../ModulePriceDialog";

const PriceCell = ({
  type,
  rowId,
  tempId,
  price,
  tableManager,
  errorMessage,
  sectionId,
  isFiller = false,
  dialogProps = {},
  price_per_sqft,
  viewMode,
  access,
}) => {
  const priceId = `price_${rowId}`;
  const isActive = tableManager.isActive(type, rowId, "price");
  const showTooltip = !price || price === "N/A";

  return (
    <Cell
      rowType={type}
      rowId={rowId}
      column="price"
      status="focus"
      className="px-1 d-flex flex-column justify-content-center flex-grow-0"
      customStyles={{ width: isMobileOnly ? "15%" : "60px" }}
      tableManager={tableManager}
      isTemp={tempId}
      errorMessage={errorMessage}
      isFillerRow={isFiller}
      sectionId={sectionId}
    >
      <p className="m-0" id={priceId}>
        {price && price !== "N/A" ? `₹${price.toLocaleString("en-IN")}` : "?"}
      </p>
      {access.view_price_detail && (
        <span className="mt-1 text-muted" style={{ fontSize: "9px" }}>
          {price_per_sqft && price_per_sqft !== "N/A"
            ? `₹${price_per_sqft.toLocaleString("en-IN")} / sqft`
            : "?"}
        </span>
      )}
      {showTooltip && (
        <UncontrolledTooltip target={priceId} placement="top">
          Refresh Project Price to View
        </UncontrolledTooltip>
      )}

      {access.view_price_detail &&
        type === "module" &&
        price &&
        price !== "N/A" &&
        isActive &&
        viewMode !== "review" && <ModulePriceDialog {...dialogProps} />}
    </Cell>
  );
};

export default PriceCell;
